var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"card col-md-12"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-11"},[_c('div',{staticClass:"card-body"},[_c('eventosSivigila')],1)])])]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12"},[_c('br')])
}]

export { render, staticRenderFns }